export const SETTINGS = "SETTINGS";
export const SWAGGER = "SWAGGER";
export const FRESHDESK_TICKETS = "FRESHDESK_TICKETS";
export const FRESHDESK_TICKET_CONVERSATIONS = "FRESHDESK_TICKET_CONVERSATIONS";
export const FRESHDESK_ANALYTICS = "FRESHDESK_ANALYTICS";
export const SHOPIFY_ORDER_HISTORY = "SHOPIFY_ORDER_HISTORY";
export const CLICKUP_TASKS = "CLICKUP_TASKS";
export const CLICKUP_ANALYTICS = "CLICKUP_ANALYTICS";
export const TENANTS = "TENANTS";
export const USER_INFO = "USER_INFO";
export const SAVED_VIEWS = "SAVED_VIEWS";

// Org Settings
export const ORG_SEATS = "ORG_SEATS";
export const ORG_USERS = "ORG_USERS";
export const ORG_BOOTSTRAP = "ORG_BOOTSTRAP";
